import { ChatContainer, ConversationHeader, MessageInput, MessageList } from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { IconButton, TextField, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { sendMessageProviderChat } from 'services/chat.services';
import { Provider } from '../Details/BookingDetail/Provider';
import { providerChatChannelState } from 'pages/CustomerBooking';
import { clientState } from '../RecoilState';

import { MessageContent } from './MessageContent';
import { useStyles } from './styles';
import { useState } from 'react';
import isEmpty from 'lodash.isempty';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import useDocumentHeight from 'util/useDocumentHeight';

const ProviderChat = ({ appBar, messageList = [], reloadMessages = () => { } }) => {
  const classes = useStyles()
  const conversationId = useRecoilValue(providerChatChannelState);
  const [chatValue, setChatValue] = useState('');
  const clientStatus = useRecoilValue(clientState)
  const webkitDocHeight = useDocumentHeight()

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"), {
    noSsr: true,
  });

  const sendProviderMessageCallback = useCallback(
    async (message) => {
      const result = await sendMessageProviderChat(conversationId, message)
      console.log("📢[index.jsx:89]: ", result);
      reloadMessages()
    },
    [conversationId],
  );

  const theme = useTheme()
  return (
    <>
      <ChatContainer className={isMobile ? '' : classes.chatContainer}>
        <ConversationHeader>
          <ConversationHeader.Content>
            {appBar}
          </ConversationHeader.Content>
        </ConversationHeader>
        <ConversationHeader>
          <ConversationHeader.Content ><Typography variant="h6" className={classes.title}>
            Provider Chat {conversationId}
          </Typography>
            <Provider
              screen="Chat"
              compact
              disableDetails
              provider={clientStatus?.appointment?.provider} asCard
            />
          </ConversationHeader.Content>
        </ConversationHeader>

        <MessageList 
          style={{

            overflowY: 'scroll',
            overflowX: 'hidden',
            height: `calc(${webkitDocHeight}px - 200px)`,

          }} 
          autoScrollToBottom={false}
        >
          {messageList.map((message, index) =>
            <MessageContent message={message} key={index} />
          )}
        </MessageList>
        <div as={MessageInput} style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          borderTop: "1px dashed #d1dbe4",
          marginBottom: "calc(20px + env(keyboard-inset-height))",
        }}>
          <div style={{ display: 'flex', flexDirection: 'row', flex: 1, paddingRight: 10 }}>
            <TextField
              autoFocus
              placeholder='Type message here'
              value={chatValue}
              onChange={e => setChatValue(e.target.value)}
              variant="outlined"
              fullWidth
              size="small"
              color="primary"
              multiline
              maxRows={4}
              style={{
                margin: theme.spacing(1),
              }}
              InputProps={{
                style: {
                  padding: theme.spacing(1),
                  fontSize: theme.typography.body2.fontSize,
                }
              }}
              InputLabelProps={{
                style: {
                  display: 'none'
                }
              }}
            />
            <IconButton size="small"
              color='primary'
              onClick={() => {
                sendProviderMessageCallback(chatValue)
              }}
              disabled={isEmpty(chatValue)}
            >
              <FontAwesomeIcon icon={faPaperPlane} />
            </IconButton>
          </div>
        </div>

      </ChatContainer>
    </>
  )
}

export { ProviderChat };
